import { render, staticRenderFns } from "./PagePreloader.vue?vue&type=template&id=66499f96"
import script from "./PagePreloader.vue?vue&type=script&lang=js"
export * from "./PagePreloader.vue?vue&type=script&lang=js"
import style0 from "./PagePreloader.vue?vue&type=style&index=0&id=66499f96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports